const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#333333',
                hover: '#4d4d4d'
            },
            secondary: {
                main: '#fff'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
